'use client';

import type { ReactNode } from 'react';
import { formatBadgeCount } from '@/lib/formatBadgeCount';

export type BadgeVariant = 'default' | 'host' | 'cohost' | 'live' | 'rec' | 'warning';

export function Badge({
  variant = 'default',
  dot,
  children,
  className,
}: {
  variant?: BadgeVariant;
  dot?: boolean;
  children: ReactNode;
  className?: string;
}) {
  const cls = ['mx-badge', variant !== 'default' && `mx-badge--${variant}`, className].filter(Boolean).join(' ');
  return (
    <span className={cls}>
      {dot && <span className="mx-badge__dot" />}
      {children}
    </span>
  );
}

export function Chip({ children, onRemove, className }: { children: ReactNode; onRemove?: () => void; className?: string }) {
  return (
    <span className={`mx-chip${className ? ` ${className}` : ''}`}>
      {children}
      {onRemove && (
        <button type="button" className="mx-chip__remove" aria-label="Hapus" onClick={onRemove}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 6 6 18M6 6l12 12" />
          </svg>
        </button>
      )}
    </span>
  );
}

export function CountBadge({
  count,
  variant = 'default',
  className,
}: {
  count: number;
  variant?: 'default' | 'warning';
  className?: string;
}) {
  const label = formatBadgeCount(count);
  if (label === null) return null;
  const cls = ['mx-control__badge', variant === 'warning' && 'mx-control__badge--warning', className]
    .filter(Boolean)
    .join(' ');
  return <span className={cls}>{label}</span>;
}
